import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbNav, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs/operators';
import { Company } from 'src/app/domains/companies/models';
import { EquipmentContent } from 'src/app/domains/equipment/models';
import { EquipmentService } from 'src/app/domains/equipment/services';

@Component({
  selector: 'gdp-single-equipment',
  templateUrl: './single-equipment.component.html',
  styleUrls: ['./single-equipment.component.scss']
})
export class SingleEquipmentComponent implements OnInit {
  @Input() company: Company;
  active: string;
  currentTab = 'overview';
  @ViewChild('nav', { static: false }) nav: NgbNav;
  private TABS = [
    'overview',
    'provisioning'
  ];

  public TAB_ICONS = {
    'overview': 'icon-small-info',
    'provisioning': 'icon-small-delivery'
  }

  public loading: boolean = false;
  public equipment: EquipmentContent;
  public mac_address: string;
  public errorMessage: string = null;
  public handsetChanged: boolean = false;

  constructor(
    config: NgbDropdownConfig,
    private equipmentService: EquipmentService,
    private route: ActivatedRoute,
    private router: Router
    ) {
    config.placement = 'bottom';
    config.autoClose = true;
  }

  ngOnInit() {
    const p = this.route.snapshot.params;
    if (p.mac) {
      this.fetchEquipment(p.mac);
      this.mac_address = p.mac;
    }
    // this.route.params
    //   .pipe(take(1))
    //   .subscribe((p: { mac: string }) => {
    //     if (p.mac) {
    //       this.fetchEquipment(p.mac)
    //       this.mac_address = p.mac;
    //     }
    //   });
  }

  onNavChange(c: NgbNavChangeEvent) {
    this.currentTab = c.nextId;
  }

  public switchTab(tabId: string): void {
    this.nav.select(tabId);
    this.currentTab = tabId; // select doesn't trigger onNavChange
  }

  private fetchEquipment(id: string) {
    this.loading = true;
    this.equipmentService.getEquipmentByMacAddress(id,
      [
        {
          status: 404,
          message: 'equipment.filters.errors.macAddress-not-found'
        },
        {
          status: 500,
          message: 'equipment.filters.errors.macAddress-invalid'
        }
      ])
    .pipe(take(1)).subscribe((e: EquipmentContent) => {
      this.equipment = e;
      this.errorMessage = null;
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  onDeallocatePbx(event: boolean) {
    this.handsetChanged = event;
  }

  goToEquipment() {
    this.router.navigate(['../'], { relativeTo: this.route});
  }
}
